// Bohol Municipalities and City
// Complete list of all 47 towns + 1 city in Bohol Province
export const BOHOL_TOWNS = [
  "Alburquerque",
  "Alicia",
  "Anda",
  "Antequera",
  "Baclayon",
  "Balilihan",
  "Batuan",
  "Bilar",
  "Buenavista",
  "Calape",
  "Candijay",
  "Carmen",
  "Catigbian",
  "Clarin",
  "Corella",
  "Cortes",
  "Dagohoy",
  "Danao",
  "Dauis",
  "Dimiao",
  "Duero",
  "Garcia Hernandez",
  "Getafe",
  "Guindulman",
  "Inabanga",
  "Jagna",
  "Lila",
  "Loay",
  "Loboc",
  "Loon",
  "Mabini",
  "Maribojoc",
  "Panglao",
  "Pilar",
  "President Carlos P. Garcia",
  "Sagbayan",
  "San Isidro",
  "San Miguel",
  "Sevilla",
  "Sierra Bullones",
  "Sikatuna",
  "Tagbilaran City",
  "Talibon",
  "Trinidad",
  "Tubigon",
  "Ubay",
  "Valencia"
].sort(); // Alphabetically sorted for dropdown

// Predefined Skills for Worker Profiles
// Maximum 12 skills can be selected
export const WORKER_SKILLS = [
  { value: 'housekeeping', label: 'Housekeeping' },
  { value: 'customer_service', label: 'Customer Service' },
  { value: 'waiting_staff', label: 'Waiting Staff' },
  { value: 'bartending', label: 'Bartending' },
  { value: 'cooking', label: 'Cooking' },
  { value: 'tour_guiding', label: 'Tour Guiding' },
  { value: 'driving', label: 'Driving (car/van)' },
  { value: 'motorcycle_delivery', label: 'Motorcycle Delivery' },
  { value: 'diving_instructor', label: 'Diving Instructor' },
  { value: 'massage_therapy', label: 'Massage Therapy' },
  { value: 'carpentry', label: 'Carpentry' },
  { value: 'masonry', label: 'Masonry' },
  { value: 'plumbing', label: 'Plumbing' },
  { value: 'electrical', label: 'Electrical' },
  { value: 'painting', label: 'Painting' },
  { value: 'welding', label: 'Welding' },
  { value: 'gardening', label: 'Gardening' },
  { value: 'landscaping', label: 'Landscaping' },
  { value: 'graphic_design', label: 'Graphic Design' },
  { value: 'video_editing', label: 'Video Editing' },
  { value: 'social_media_management', label: 'Social Media Management' },
  { value: 'teaching_tutoring', label: 'Teaching/Tutoring' },
  { value: 'nursing_caregiving', label: 'Nursing/Caregiving' },
  { value: 'security_guard', label: 'Security Guard' },
  { value: 'boat_captain', label: 'Boat Captain' },
  { value: 'fishing', label: 'Fishing' },
  { value: 'farming', label: 'Farming' },
  { value: 'retail_sales', label: 'Retail Sales' },
  { value: 'receptionist', label: 'Receptionist' },
  { value: 'admin_office', label: 'Admin/Office Work' },
  { value: 'accounting_bookkeeping', label: 'Accounting/Bookkeeping' },
  { value: 'cleaning', label: 'Cleaning' },
  { value: 'laundry', label: 'Laundry' },
  { value: 'maintenance', label: 'Maintenance' },
  { value: 'construction_labor', label: 'Construction Labor' },
  { value: 'other', label: 'Other (specify)' }
];

// Years of Experience Options
export const YEARS_OF_EXPERIENCE = [
  { value: 'less_than_1', label: 'Less than 1 year' },
  { value: '1_to_3', label: '1–3 years' },
  { value: '3_to_5', label: '3–5 years' },
  { value: '5_to_10', label: '5–10 years' },
  { value: '10_plus', label: '10+ years' }
];

// Education Levels
// Master's and Doctorate/PhD are intentionally merged into a single "Post Graduate"
// level (value 'masters'), matching the official PESO/NSRP form which uses one
// "Post Graduate" level. Legacy 'doctorate' rows normalize to 'masters' on load and
// display as "Post Graduate" (see getEducationLabel + normalizeEducationLevel below).
export const EDUCATION_LEVELS = [
  { value: 'elementary', label: 'Elementary' },
  { value: 'high_school', label: 'High School Graduate' },
  { value: 'vocational', label: 'Vocational/Technical' },
  { value: 'college_level', label: 'College Level' },
  { value: 'college_graduate', label: 'College Graduate' },
  { value: 'bachelors', label: 'Bachelors Degree' },
  { value: 'masters', label: 'Post Graduate' }
];

// Coerce a stored education_level to the canonical set for form <Select> binding.
// 'doctorate' is a retired value merged into 'masters' (Post Graduate).
export const normalizeEducationLevel = (value) =>
  value === 'doctorate' ? 'masters' : (value || '');

// Human-readable label for a stored education_level (handles the retired 'doctorate').
export const getEducationLabel = (value) => {
  if (!value) return '';
  if (value === 'masters' || value === 'doctorate') return 'Post Graduate';
  return EDUCATION_LEVELS.find((e) => e.value === value)?.label || value;
};

// Availability Options
export const AVAILABILITY_OPTIONS = [
  { value: 'immediate', label: 'Immediate' },
  { value: 'within_1_week', label: 'Within 1 week' },
  { value: 'within_2_weeks', label: 'Within 2 weeks' },
  { value: 'within_1_month', label: 'Within 1 month' },
  { value: 'flexible', label: 'Flexible' }
];

// Work Type Preferences
export const WORK_TYPE_OPTIONS = [
  { value: 'full_time', label: 'Full-time' },
  { value: 'part_time', label: 'Part-time' },
  { value: 'project_based', label: 'Project-based' },
  { value: 'seasonal', label: 'Seasonal/Temporary' }
];

// Common Benefits for Job Posts
export const COMMON_BENEFITS = [
  'SSS',
  'PhilHealth',
  'Pag-IBIG',
  '13th Month Pay',
  'HMO',
  'Vacation Leave',
  'Sick Leave',
  'Overtime Pay',
  'Night Differential',
  'Holiday Pay',
  'Performance Bonus',
  'Rice Subsidy',
  'Transportation Allowance',
  'Meal Allowance',
  'Free Meals',
  'Free Accommodation',
  'Skill Training'
];